import SingleModelInterface from '../../types/singleModelInterface'

export default function filterByCarType(
    carTypes: string[],
    allModels: SingleModelInterface[]
): SingleModelInterface[] {
    if (carTypes.length) {
        return allModels.filter((model: SingleModelInterface) =>
            carTypes.includes(model.category.name)
        )
    }

    return allModels
}
